import * as uuid from "uuid";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";

export class LineHandlesModel {
  shapeId;
  lineId;
  id;
  featureId;
  qtCatName;
  partId;
  quantityInGroup;
  quantityGroup;
  constructor(shapeId,
              lineId,
              featureId,
              id = uuid.v4(),
              qtCatName = null,
              partId = null,
              quantity = 1, // this is number of handles from the filters
              quantityInGroup = 0, // this is number of doors or drawers (not used)
              quantityGroup = null,
  ) {
    this.shapeId = shapeId;
    this.lineId = lineId;
    this.featureId = featureId;
    this.id = id;
    this.qtCatName = qtCatName ? qtCatName : getQtCatName();
    this.partId = partId;
    this.quantity = quantity;
    this.quantityInGroup = quantityInGroup;
    this.quantityGroup = quantityGroup;
  }
}
